import { lazy } from "react";
import type { RouteConfig } from "../config";
import { ROUTES } from "../paths";

const ProductsPage = lazy(() =>
  import("@/pages/products").then((m) => ({ default: m.ProductsPage }))
);
const ProductViewPage = lazy(() =>
  import("@/pages/products/product-detail-page").then((m) => ({
    default: m.ProductViewPage,
  }))
);

const PRODUCT_READ = { access: "permission" as const, entity: "products", action: "READ" };

export const productRoutes: RouteConfig[] = [
  { path: ROUTES.PRODUCTS.LIST, component: ProductsPage, layout: "dashboard", permissions: PRODUCT_READ },
  { path: ROUTES.PRODUCTS.DETAIL, component: ProductViewPage, layout: "dashboard", permissions: PRODUCT_READ },
];
